import { IJsonQueryNewbuilding } from '../../../../api-models/common/json_query';
import { createGeoTagsManager } from '../../utils/createGeoTagsManager';

export const geoNewbuildingTagsManager = createGeoTagsManager<IJsonQueryNewbuilding>({
  jsonQueryKey: 'newobject',
  labelGetter: ({ geoTags, geoValue }) => geoTags.newbuildings[geoValue.id] || 'Неизвестный ЖК',
  id: 'geoNewbuilding',
});
